import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

import Side from './side/Side';
import GMap from './gmap/GMap';
import Navigator from './navigator/Navigator';

import DatabaseService from './../services/DatabaseService';
import { piezometriService } from '../services/PiezometriService';

const ID_SITO = 1;


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  background-color: #ffffff;
	width: 100%;
	height: 100%;
  overflow: hidden !important;
`;
const ToggleSearch = styled.div.withConfig({displayName:'-ToggleSearch'})`
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 998;
	width: 41px;
	height: 41px;
	background-color: #0d609d;
	cursor: pointer;
	display: flex;
	justify-content: space-around;
	align-items: center;
	color: #ffffff;
	font-size: 20px;
`;
const ToggleLayers = styled.div.withConfig({displayName:'-ToggleLayers'})`
	position: absolute;
  top: 0px;
  left: 41px;
  z-index: 998;
  width: 41px;
  height: 41px;
  background-color: #0d609d;
  cursor: pointer;
	display: flex;
	justify-content: space-around;
	align-items: center;
	color: #ffffff;
	font-size: 20px;
`;
const Mover = styled.div.withConfig({displayName:'-Mover'})`
	position: absolute;
  top: 0;
  left: ${props => props.isMoved ? 0 : -550}px;
  width: calc(100% + 550px);
  height: 100%;
  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
`;


const Map = ({
	lang = "it",
	layout
}) => {

  const [lv0, setLv0] = useState(null);

  const [lv1, setLv1] = useState(null);
  const [hoverLv1, setHoverLv1] = useState(null);

  const [lv2, setLv2] = useState(null);
  const [hoverLv2, setHoverLv2] = useState(null);

  const [lv3, setLv3] = useState(null);
  const [hoverLv3, setHoverLv3] = useState(null);

  const [lv4, setLv4] = useState(null);
  const [hoverLv4, setHoverLv4] = useState(null);

  const [showSearch, setShowSearch] = useState(null);
  const [showLayers, setShowLayers] = useState(null);

  const [listLv1, setListLv1] = useState([]);
  const [listLv2, setListLv2] = useState([]);
  const [listLv3, setListLv3] = useState([]);
  const [listLv4, setListLv4] = useState([]);
  const [listLv5, setListLv5] = useState([]);

  const [listDocs, setListDocs] = useState([]);
	
  const [showListLv1, setShowListLv1] = useState([]);
  const [showListLv2, setShowListLv2] = useState([]);

	const [fullListLv2, setFullListLv2] = useState([]);
	const [fullListLv3, setFullListLv3] = useState([]);
	const [fullListLv4, setFullListLv4] = useState([]);

  const [showListCartografie, setShowListCartografie] = useState([]);
  const [mapType, setMapType] = useState("terrain");

  useEffect(() => { 
    DatabaseService.getSito(ID_SITO).then((response) => {
    	setLv0(response);	
    });
    DatabaseService.listMacrolotti(ID_SITO).then((response) => {
    	setListLv1(response);	
    	setShowListLv1(response);	
    });
		
		DatabaseService.listSubaree().then((response) => {
			setFullListLv2(response);
    	setShowListLv2(response);	
		});
		
		Promise.all([
			DatabaseService.listSondaggi(),
			piezometriService.getAll()
		])
		.then(([sondaggi, piezometri]) => {
			setFullListLv3([...sondaggi, ...piezometri]);
		});
		
		DatabaseService.listCampioni().then((response) => {
			setFullListLv4(response);
		});

		DatabaseService.listDocumenti("santa-barbara","rdp").then((response) => {
			setListDocs(response);
		});
  }, []);

  useEffect(() => { 
		if(lv1){
			DatabaseService.listSubaree(lv1.id).then((response) => {
				setListLv2(response);	
			});
		}else{
			setListLv2(null);	
		}
  }, [lv1]);

  useEffect(() => { 
		if(lv2){
			Promise.all([
				DatabaseService.listSondaggi(lv2.id),
				piezometriService.getBySubarea(lv2.id)
			])
			.then(([sondaggi, piezometri]) => {
				setListLv3([...sondaggi, ...piezometri]);	
			});
		}else{
			setListLv3(null);	
		}
  }, [lv2]);

  useEffect(() => { 
		if(lv3){
			if (lv3.tipo !== 'Piezómetro') {
				DatabaseService.listCampioni(lv3.id)
				.then(response => {
					setListLv4(response);
				});
			}
		}else{
			setListLv4(null);	
		}
  }, [lv3]);

  useEffect(() => { 
		if(lv4){
			DatabaseService.listDati(lv4.id).then((response) => {
				console.log('DATI', response)
				setListLv5(response);	
			});
		}else{
			setListLv5(null);	
		}
  }, [lv4]);

  return (
    <Wrapper>
			<ToggleSearch onClick={() => {setShowSearch(true); setShowLayers(false);}}>
				<i className="fa-solid fa-magnifying-glass"></i>
			</ToggleSearch>
			<ToggleLayers onClick={() => {setShowSearch(false); setShowLayers(true);}}>
				<i className="fa-solid fa-layer-group"></i>
			</ToggleLayers>

			<Mover isMoved={showLayers || showSearch}>
				<Side
					onClose={() => {
						setShowSearch(false);
						setShowLayers(false);
					}}
					showLayers={showLayers}
					showSearch={showSearch}
					idSito={ID_SITO}
					fullListLv1={listLv1}
					showListLv1={showListLv1}
					setShowListLv1={setShowListLv1}
					showListLv2={showListLv2}
					setShowListLv2={setShowListLv2}
					fullListLv3={fullListLv3}
					fullListLv4={fullListLv4}
					showListCartografie={showListCartografie}
					setShowListCartografie={setShowListCartografie}
					mapType={mapType}
					setMapType={setMapType}
				/>				
				<GMap
					mapType={mapType}
					showListCartografie={showListCartografie}
					fullListLv1={listLv1}
					showListLv1={showListLv1}
					lv1={lv1}
					setLv1={setLv1}
					hoverLv1={hoverLv1}
					setHoverLv1={setHoverLv1}
					fullListLv2={fullListLv2}
					showListLv2={showListLv2}
					lv2={lv2}
					setLv2={setLv2}
					hoverLv2={hoverLv2}
					setHoverLv2={setHoverLv2}
					fullListLv3={fullListLv3}
					// showListLv3={showListLv3}
					lv3={lv3}
					setLv3={setLv3}
					hoverLv3={hoverLv3}
					setHoverLv3={setHoverLv3}
					setLv4={setLv4}
				/>				
				<Navigator
					listLv1={listLv1}
					listLv2={listLv2}
					listLv3={listLv3}
					listLv4={listLv4}
					listLv5={listLv5}
					lv0={lv0}
					lv1={lv1}
					setLv1={setLv1}
					hoverLv1={hoverLv1}
					setHoverLv1={setHoverLv1}
					lv2={lv2}
					setLv2={setLv2}
					hoverLv2={hoverLv2}
					setHoverLv2={setHoverLv2}
					lv3={lv3}
					setLv3={setLv3}
					hoverLv3={hoverLv3}
					setHoverLv3={setHoverLv3}
					lv4={lv4}
					setLv4={setLv4}
					hoverLv4={hoverLv4}
					setHoverLv4={setHoverLv4}
					listDocs={listDocs}
				/>
			</Mover>			
		</Wrapper>
  )
}

export default Map
